import React, { useState } from "react";
import {
  MeasurementInputPage as PageType,
  UserProfile,
} from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  userProfile: UserProfile;
  onAnswer: (value: { value: number; unit: string }) => void;
}

const MeasurementInputPage: React.FC<Props> = ({
  page,
  userProfile,
  onAnswer,
}) => {
  const initialData = page.data_field
    ? (userProfile[page.data_field] as any)
    : null;
  const [value, setValue] = useState<string>(
    initialData?.value?.toString() || "",
  );
  const [unit, setUnit] = useState<string>(
    initialData?.unit || page.defaultUnit,
  );
  const [error, setError] = useState<string | null>(null);

  // For height in ft/in
  const [feet, setFeet] = useState<string>("");
  const [inches, setInches] = useState<string>("");

  const handleSubmit = () => {
    let numValue: number;

    if (page.measurementType === "height" && unit === "ft/in") {
      const ft = parseInt(feet) || 0;
      const inch = parseInt(inches) || 0;
      numValue = ft * 12 + inch; // Total inches
    } else {
      numValue = parseFloat(value);
    }

    if (!numValue || numValue <= 0) {
      setError("Please enter a valid value");
      return;
    }

    setError(null);
    onAnswer({ value: numValue, unit });
  };

  const renderInput = () => {
    if (page.measurementType === "height" && unit === "ft/in") {
      return (
        <div className="measurement-input__dual">
          <input
            type="number"
            className="measurement-input__field"
            placeholder="Feet"
            value={feet}
            onChange={(e) => setFeet(e.target.value)}
            min="0"
            max="8"
          />
          <span className="measurement-input__separator">ft</span>
          <input
            type="number"
            className="measurement-input__field"
            placeholder="Inches"
            value={inches}
            onChange={(e) => setInches(e.target.value)}
            min="0"
            max="11"
          />
          <span className="measurement-input__separator">in</span>
        </div>
      );
    }

    return (
      <div className="measurement-input__single">
        <input
          type="number"
          className="measurement-input__field"
          placeholder={`Enter ${page.measurementType}`}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          min="0"
          step="0.1"
        />
        <span className="measurement-input__unit">{unit}</span>
      </div>
    );
  };

  return (
    <div className="page page--measurement-input">
      <div className="page__container">
        <h2 className="page__question">{page.question}</h2>

        {/* Unit Toggle */}
        {page.units.length > 1 && (
          <div className="unit-toggle">
            {page.units.map((u) => (
              <button
                key={u}
                className={`unit-toggle__button ${
                  unit === u ? "unit-toggle__button--active" : ""
                }`}
                onClick={() => setUnit(u)}
              >
                {u}
              </button>
            ))}
          </div>
        )}

        {/* Input */}
        <div className="measurement-input">
          {renderInput()}
          {error && <p className="measurement-input__error">{error}</p>}
        </div>

        <button className="page__button" onClick={handleSubmit}>
          {page.buttonText}
        </button>
      </div>
    </div>
  );
};

export default MeasurementInputPage;
